<template>
  <div>
    <swiper class="home-banner" :options="swiperOption">
      <swiper-slide v-for="slide in slides" :key="slide.href">
        <a target="_blank" :href="slide.href"><img :src="slide.image"/></a>
      </swiper-slide>
      <div v-if="hasMultipleSlides" class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/dist/swiper.css'

export default {
  name: "UserRead",
  components: { swiper, swiperSlide },
  data() {
    return {
      slides: [
        // {
        //   href: 'https://help.meiwulist.com/help/msq/pages/2025/announcement.html',
        //   image: 'https://shouqu.oss-cn-shanghai.aliyuncs.com/cms/160/images/1744364340332213515.png'
        // },
        {
          href: 'https://help.meiwulist.com/push/2018/0930website.html',
          image: 'https://shouqu.oss-cn-shanghai.aliyuncs.com/cms/162/images/1665214494028986505.png'
        }
      ]
    }
  },
  computed: {
    hasMultipleSlides() {
      return this.slides.length > 1
    },
    swiperOption() {
      const options = {
        loop: this.hasMultipleSlides,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }

      if (this.hasMultipleSlides) {
        options.autoplay = {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        }
        options.pagination = {
          el: '.swiper-pagination',
          clickable: true
        }
      }

      return options
    }
  }
}
</script>

<style>
.home-banner {
  height: 230px;
}

.home-banner .swiper-slide img {
  display: block;
  width: 100%;
  height: 230px;
  object-fit: cover;
}

.swiper-pagination-bullet-active {
  background: #ffffff;
}
</style>
